import {AfterContentChecked, ChangeDetectorRef, Component, forwardRef, Input, OnInit} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { formControlErrorKeys, formControlErrorMessage, setupUntilDestroy } from '@portal-workspace/grow-ui-library';
import { MARK, Mark } from '@portal-workspace/grow-ui-library/mark';
import { createAcnInputMask } from '@portal-workspace/grow-ui-library';
import { Subscription } from 'rxjs';
import { AbstractControlValueAccessor } from '../abstract-control-value-accessor';
import {delay, distinctUntilChanged, tap} from 'rxjs/operators';
import {AcnComponentValue, compareMatch} from '@portal-workspace/grow-shared-library';

import { InputMaskModule } from '@ngneat/input-mask';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {DisableControlDirective} from '../../directives/disable-control.directive';


@UntilDestroy()
@Component({
    selector: 'acn',
    templateUrl: './acn.component.html',
    styleUrls: ['./acn.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AcnComponent), multi: true },
        { provide: MARK, useExisting: forwardRef(() => AcnComponent) },
    ],
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, FormsModule, InputMaskModule, ReactiveFormsModule, DisableControlDirective]
})
export class AcnComponent extends AbstractControlValueAccessor<AcnComponentValue> implements OnInit, AfterContentChecked, Mark {

  @Input({required: false}) isMandatory = true;
  errorKeys = formControlErrorKeys;
  errorMessage = formControlErrorMessage;
  formControl!: FormControl<AcnComponentValue>;
  formGroup!: FormGroup<{
    acn: FormControl<AcnComponentValue>
  }>;
  subscription?: Subscription;
  createAcnInputMask = createAcnInputMask();

  constructor(private formBuilder: FormBuilder,
              private cdr: ChangeDetectorRef) {
    super();
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    setupUntilDestroy(this);
    this.formControl = new FormControl(null, this.isMandatory ? [Validators.required] : null);
    this.formGroup = this.formBuilder.group({
      acn: this.formControl,
    });
    this.subscription = this.formControl.valueChanges.pipe(
      delay(0),
      distinctUntilChanged(compareMatch),
      tap((v: any) => {
        // A disabled field is not an invalid one: its group reports DISABLED rather than VALID, so
        // without this the clearing branch wipes a value the parent set itself and the user has no
        // way to restore, the field being read-only.
        if (this.disabled || this.formGroup.valid) {
          this.propagateChange(v);
        } else {
          this.propagateChange(null)
        }
      })
    ).subscribe();
  }

  doWriteValue(v: AcnComponentValue) {
    this.formControl.setValue(v);
  }

  mark(): void {
    this.formControl.markAllAsTouched();
  }

}
